import gql from 'graphql-tag';

export const GRAPHQL_QUERY_CHECKOUTS = gql`
    query checkouts($criteria:CriteriaInput){
        checkouts(criteria: $criteria){
            rows{
                id
                serial
                name
                isActive
                merchant{
                    id
                    businessName
                    brand{
                        id
                        name
                    }
                    user{
                        id
                        firstName
                        lastName
                    }
                }
                createdAt
            }
            total
            id
        }
    }
`;

export const GRAPHQL_MUTATION_UPDATE_CHECKOUT = gql`
    mutation updateCheckout($checkoutInput: UpdateCheckoutInput!) {
        updateCheckout(checkoutInput: $checkoutInput) {
            id
            serial
            name
            isActive
        }
    }
`;

export const GRAPHQL_MUTATION_ADD_CHECKOUT = gql`
    mutation addCheckout($checkoutInput: AddCheckoutInput!) {
        addCheckout(checkoutInput: $checkoutInput) {
            id
            serial
            name
            isActive
            merchant{
                id
                businessName
                brand{
                    id
                    name
                }
                user{
                    id
                    firstName
                    lastName
                }
            }
            createdAt
        }
    }
`;


